import Swiper from "swiper";

const mainTabsButtons = document.querySelectorAll('[data-target="main-tab-button"]');
const mainTabs = document.querySelectorAll('[data-target="main-tab"]');

if (mainTabsButtons.length) {
    mainTabsButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            let tabGroup = button.getAttribute('data-tab_group');
            let tabId = button.getAttribute('data-tab_id');

            mainTabsButtons.forEach(function (el) {
                if (el.getAttribute('data-tab_group') === tabGroup)
                    el.classList.remove('--active');
            });

            button.classList.add('--active');
            let seeAll = document.querySelector(`[data-see_all_id="${tabGroup}"]`);
            if(seeAll){
                let url = seeAll.getAttribute('href');
                url = new URL(url);
                url.searchParams.set('filter[realty_type_id][0]', tabId);
                seeAll.setAttribute('href', url.href);
            }

            if (mainTabs.length) {
                mainTabs.forEach(function (tab) {
                    if (tab.getAttribute('data-tab_group') === tabGroup)
                        tab.style.display = 'none'
                    if (tab.getAttribute('data-tab_group') === tabGroup &&
                        tab.getAttribute('data-tab_id') === tabId)
                        tab.style.display = 'block';
                })
            }


        })
    })
}

let offerSwiperList = [];
const offerSliders = document.querySelectorAll('.offer-slider');
offerSliders.forEach(function (slider) {
    let newSlider = new Swiper(slider, {
        virtual: {
            enabled: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: 24,
            },
            490: {
                slidesPerView: 1.5,
                spaceBetween: 24,
            },
            576: {
                slidesPerView: 1.7,
                spaceBetween: 24,
            },
            767: {
                slidesPerView: 2.3,
                spaceBetween: 24,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1260: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
    });
    offerSwiperList.push(newSlider);
})


const loadMoreButtonsMain = document.querySelectorAll('[data-target="main_load_more"]');
if (loadMoreButtonsMain.length) {
    loadMoreButtonsMain.forEach(function (button) {
        button.addEventListener('click', function (e) {
            let sliderId = button.getAttribute('data-slider_id');
            let bfId = button.getAttribute('data-bf_id');
            let tId = button.getAttribute('data-type_id');
            let totalPages = parseInt(button.getAttribute('data-total_pages'));
            let needPage = parseInt(button.getAttribute('data-page'));

            fetch(`/json/${bfId}/${tId}/${needPage}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
            }).then((response) => response.text())
                .then((html) => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, 'text/html');

                    let container = document.querySelector('[data-target="main-tab"][data-tab_id="' + tId + '"][data-tab_group="' + bfId + '"] .result-grid-main .swiper-wrapper');

                    doc.querySelectorAll('.swiper-slide-main').forEach(function (elem) {
                        container.appendChild(elem);
                        let slider = elem.querySelector('.card-slider');
                        if (slider) {
                            new Swiper(slider, {
                                slidesPerView: 1,
                                speed: 1000,
                                effect: "fade",
                                nested: true,
                                pagination: {
                                    el: elem.querySelector(
                                        ".card-slider__pagination.swiper-pagination"
                                    ),
                                    type: "bullets",
                                    clickable: true,
                                },
                                navigation: {
                                    nextEl: slider.querySelector(".card-slider__next"),
                                    prevEl: slider.querySelector(".card-slider__prev"),
                                },
                            });
                        }
                    })
                    offerSwiperList[sliderId].update();
                    offerSwiperList[sliderId].slideTo(needPage*3);

                    needPage = needPage + 1;
                    if (needPage > totalPages)
                        button.style.display = 'none';
                    else
                        button.setAttribute('data-page', needPage);

                });
        });

    });
}
